import { Controller } from "@hotwired/stimulus";
import { useOutlets } from "hb/insights/use_outlets";

export default class extends Controller {
  static targets = ["deploymentItem", "metric"];

  connect() {
    useOutlets(this);
  }

  shouldReload(widget) {
    return widget.override_time !== true;
  }
}
